module.exports = __webpack_public_path__ + "img/image18-1.d2f262d8.png";